import { cn } from '@dfh-corp-sites/ui/utils'
import React, { FC } from 'react'

export interface ItemImagePreviewProps {
  className?: string
  src: string
  srcSet?: string
  alt: string
  selected?: boolean
  size?: 'sm' | 'lg'
  onImageSelected: () => void
}

const ItemImagePreview: FC<ItemImagePreviewProps> = ({
  className,
  src,
  srcSet,
  alt,
  selected = false,
  size = 'sm',
  onImageSelected,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onImageSelected()
    }
  }

  return (
    <button
      type="button"
      className={cn(
        'focus:outline-none focus:ring-2 rounded-md mr-2 last:mr-0 sm:mb-2 sm:mr-0 sm:last:mb-0',
        selected ? 'border-2 border-brand-blue' : 'border-2 border-transparent',
        className,
      )}
      aria-pressed={selected}
      onClick={onImageSelected}
      onKeyDown={handleKeyDown}
    >
      <img
        className={cn(
          'object-contain',
          size === 'sm' ? 'w-[45px] h-[45px]' : 'xl:w-[72px] xl:h-[72px]',
        )}
        src={src}
        srcSet={srcSet}
        alt={alt}
      />
    </button>
  )
}

export default ItemImagePreview
